import React from "react";
import Layout from "@/components/layout";
import HeaderOne from "@/components/header-one";
import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import BlogTwo from "@/components/blog-two";
import blogImage from '../images/novedades_desktop.jpg'


const Blog = () => {

  return (
    <MenuContextProvider>
      <Layout PageTitle="Novedades">
        <HeaderOne showTagFilter={true} />
        <PageHeader title="Novedades" altImage={blogImage} />
        <BlogTwo />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default Blog;
